/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { MsalProvider } from "@azure/msal-react";
import { Env } from "./env";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const container = document.getElementById("root")!;
const root = createRoot(container);

export const msalInstance = new PublicClientApplication(msalConfig);
const stripePromise = loadStripe(Env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

root.render(
    <React.Fragment>
        <BrowserRouter>
            <Provider store={store}>
                <MsalProvider instance={msalInstance}>
                    <Elements stripe={stripePromise}>
                        <App />
                    </Elements>
                </MsalProvider>
            </Provider>
        </BrowserRouter>
    </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
